export default __webpack_public_path__ + "static/media/keyboard-back.bac63088.svg";